import { prop } from 'js/utils/ramda.util';
import { useMemo, useCallback } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';

import * as helpers from '../helpers';
import { PERIODS } from '../constants';
import { useDynamicReducerSelector } from '../store';

export const useScheduledBreaks = () => {
    const formatter = useFormatter();
    const scheduledBreaks = useDynamicReducerSelector(prop('scheduledBreaks'));

    const getDateTime = useCallback((dateTime, period) => {
        switch (period) {
            case PERIODS.DAILY:
                return formatter.getTimeShort(helpers.getParsedDateTime(dateTime));

            case PERIODS.WEEKLY: {
                const [day, time] = dateTime.split(' ');
                const parsedTime = helpers.getParsedDateTime(time);

                return `${day} ${formatter.getTimeShort(parsedTime)}`;
            }
            case PERIODS.ONETIME:
                return formatter.getDateTimeShort(dateTime);
            default:
                return dateTime;
        }
    }, [formatter]);

    return useMemo(() => scheduledBreaks.map(item => {
        const { start, end, period, createDate, effectiveEnd, flags, isRevoked } = item;

        return {
            ...item,
            end: getDateTime(end, period),
            start: getDateTime(start, period),
            showRevoke: flags === 0 && !isRevoked,
            createDate: formatter.getDate(formatter.parseImsDate(createDate)),
            effectiveEnd: effectiveEnd ? formatter.getDateTimeShort(formatter.parseImsDate(effectiveEnd)) : ''
        };
    }), [formatter, getDateTime, scheduledBreaks]);
};
